// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorBoundary_errorContainer__NNVDC"};